import { Flex } from "@chakra-ui/react";
import dayjs from "dayjs";
import type { APIListingEvent } from "models/types/api-listing";
import { CardRecordMeta } from "components/cards/card-record-meta";
import { useFormatMoney } from "hooks/use-format-money";
import { FooterText } from "modules/vendor-portal/screens/overview/components/feedback/footer/footer-text";
import { dateFormats } from "utils/date";

type OpenHomeEventFooterProps = {
  event: APIListingEvent;
  isTruncated?: boolean;
};
export function OpenHomeEventInsetFooter({
  event,
  isTruncated,
}: OpenHomeEventFooterProps) {
  const formatMoney = useFormatMoney();
  return (
    <CardRecordMeta wrap={isTruncated ? "nowrap" : "wrap"}>
      {event.feedback?.agent ? (
        <FooterText text={`${event.feedback.agent.name}`} />
      ) : null}

      {!event.feedback || !event.feedback.price_indication ? null : (
        <FooterText
          text={`Avg price indication ${formatMoney(
            event.feedback.price_indication,
          )}`}
        />
      )}

      <Flex direction={"row"} align={"center"} gap={2}>
        <FooterText
          text={dayjs(event.starts_at).format(dateFormats.dayMonthYear)}
        />

        {/* TODO: Add is_new badge */}
      </Flex>
    </CardRecordMeta>
  );
}
